import { CellContext } from '@tanstack/react-table';
import { BarChart, FileText } from 'lucide-react';

import { useEnvironmentId } from '@/react/hooks/useEnvironmentId';
import { NodeShellActionButton } from '@/react/kubernetes/cluster/NodeShell/NodeShellActionButton';

import { Link } from '@@/Link';
import { Icon } from '@@/Icon';
import { Button } from '@@/buttons';
import { TooltipWithChildren } from '@@/Tip/TooltipWithChildren';

import { OmniNodeRowData } from '../types';

import { columnHelper } from './helper';

export function getActions(
  metricsEnabled: boolean,
  isNodeShellEnabled: boolean
) {
  return columnHelper.accessor(() => '', {
    header: 'Actions',
    enableSorting: false,
    cell: (props) => (
      <ActionsCell
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        metricsEnabled={metricsEnabled}
        isNodeShellEnabled={isNodeShellEnabled}
      />
    ),
  });
}

function ActionsCell({
  row: { original: node },
  metricsEnabled,
  isNodeShellEnabled,
}: CellContext<OmniNodeRowData, string> & {
  metricsEnabled: boolean;
  isNodeShellEnabled: boolean;
}) {
  const nodeName = node.metadata?.name;
  const environmentId = useEnvironmentId();

  return (
    <div className="flex gap-1.5">
      {metricsEnabled && (
        <Link
          to="kubernetes.cluster.node.stats"
          params={{ nodeName }}
          className="flex items-center p-1"
          data-cy="nodeStatsButton"
        >
          <TooltipWithChildren message="Stats" position="top">
            <Icon icon={BarChart} />
          </TooltipWithChildren>
        </Link>
      )}

      {nodeName && (
        <NodeShellActionButton
          environmentId={environmentId}
          nodeName={nodeName}
          isNodeShellEnabled={isNodeShellEnabled}
        />
      )}

      <TooltipWithChildren message="Machine logs" position="top">
        <Button
          color="none"
          size="small"
          data-cy="nodeMachineLogsButton"
          className="!ml-0 !p-1 !text-blue-8"
          icon={FileText}
          as={Link}
          props={{
            to: 'kubernetes.cluster.omniMachineLogs',
            params: { nodeName },
          }}
        />
      </TooltipWithChildren>
    </div>
  );
}
